import React, { Component, Fragment } from "react";
import withAssets from "../../../../components/hoc/withAssets";
import { withTranslation } from "react-i18next";
import {
  Controls,
  Form, FormHeader, GelContentColumn,
  GelContentContainer, GelContentRow,
  Notice, TextfieldElement, ButtonSecondary, Role, FormTabs, FormTab
} from "cw-styleguide-react";
import { route } from "../../../../routes";
import {
  OPERATION_TRANSLATE_DRAFT,
  OPERATION_TRANSLATE_AMENDED,
  STATUS_AWAITING_TRANSLATION,
  STATUS_AWAITING_AMENDMENTS,
  STATUS_PUBLISHED,
  LANGUAGE_EN,
  LANGUAGE_CY,
  TRANSLATOR_UNASSIGNED,
  TAB_COURSE_DETAILS,
  TAB_COURSE_SESSIONS,
  ROLE_TRANSLATOR_MANAGER,
} from "../../../../constants";
import ErrorNavigation from "../../../../components/ErrorNavigation";
import CoursesTranslateDetailsForm from "./CoursesTranslateDetailsForm";
import CoursesTranslateSessionsForm from "./CoursesTranslateSessionsForm";
import moment from "moment";
class CoursesTranslateForm extends Component {

  render() {

    return (
      <Fragment>
        {this.props.loaded && <Fragment>

          <GelContentContainer>
            {this.props.status &&
                <p><strong>{this.props.t('local:view.courses.edit.field.currentStatus.label')}</strong>: {this.props.courses.getStatusName(this.props.status)}</p>
            }
            {this.props.audit && this.props.audit.createdBy &&
                <p><strong>{this.props.t('local:view.courses.edit.field.createdBy.label')}</strong>: {this.props.audit.createdBy.name} {moment(this.props.audit.dateCreated).format("DD/MM/YYYY HH:mm:ss")}</p>
            }
            {this.props.audit && this.props.audit.updatedBy &&
                <p><strong>{this.props.t('local:view.courses.edit.field.updatedBy.label')}</strong>: {this.props.audit.updatedBy.name} {moment(this.props.audit.dateUpdated).format("DD/MM/YYYY HH:mm:ss")}</p>
            }
            {this.props.qaDate &&
                <p><strong>{this.props.t('local:view.courses.edit.field.qaDate.label')}</strong>: {moment(this.props.qaDate).format("DD/MM/YYYY HH:mm:ss")}</p>
            }
          </GelContentContainer>

          <GelContentContainer>
            <Controls>
              <ButtonSecondary url={route('coursesTranslateManage') + this.props.query} title={this.props.t('styleguide:forms.cancel')}>{this.props.t('styleguide:forms.cancel')}</ButtonSecondary>
              {this.props.operation === OPERATION_TRANSLATE_DRAFT && <ButtonSecondary onClick={() => { this.props.saveCourse(STATUS_AWAITING_TRANSLATION) }} title={this.props.t('local:view.courses.translateDraft.controls.save')}>{this.props.t('local:view.courses.translateDraft.controls.save')}</ButtonSecondary>}
              {this.props.operation === OPERATION_TRANSLATE_AMENDED && <ButtonSecondary onClick={() => { this.props.saveCourse(STATUS_AWAITING_AMENDMENTS) }} title={this.props.t('local:view.courses.translateDraft.controls.save')}>{this.props.t('local:view.courses.translateDraft.controls.save')}</ButtonSecondary>}
              <ButtonSecondary onClick={() => { this.props.saveCourse(STATUS_PUBLISHED) }} title={this.props.t('local:view.courses.translateDraft.controls.publish')}>{this.props.t('local:view.courses.translateDraft.controls.publish')}</ButtonSecondary>
              {/* Only displays if the Venue has not been assigned to a translator */}
              {this.props.values['translatorAssigned'] === TRANSLATOR_UNASSIGNED && <ButtonSecondary onClick={() => { this.props.toggleModal(['assign'], true) }} title={this.props.t('local:view.venues.translateDraft.controls.assignToMe')}>{this.props.t('local:view.venues.translateDraft.controls.assignToMe')}</ButtonSecondary>}
              {/* only displays if a venue has been assigned to a translator and the logged in user has the role Courses_TranslatorManager */}
              <Role roles={[ROLE_TRANSLATOR_MANAGER]}>
                {this.props.values['translatorAssigned'] !== TRANSLATOR_UNASSIGNED && <ButtonSecondary onClick={() => { this.props.toggleModal(['unassign'], true) }} title={this.props.t('local:view.venues.translateDraft.controls.reassign')}>{this.props.t('local:view.venues.translateDraft.controls.reassign')}</ButtonSecondary>}
              </Role>
              <ButtonSecondary onClick={this.props.translateCourseAll} title={this.props.t('local:view.courses.translateDraft.controls.translateAll')}>{this.props.t('local:view.courses.translateDraft.controls.translateAll')}</ButtonSecondary>
            </Controls>
          </GelContentContainer>
          <GelContentContainer>
            <h1>{this.props.values.id} - {this.props.values['title'][LANGUAGE_EN]}</h1>
            <FormTabs active={this.props.errorActiveTab}>
              <FormTab id={TAB_COURSE_DETAILS} label={this.props.t('local:view.courses.' + this.props.operation + '.tabs.courseDetails.label')} onClick={(e) => this.props.handleClearActiveErrors()}>
                <CoursesTranslateDetailsForm {...this.props} />
              </FormTab>
              <FormTab id={TAB_COURSE_SESSIONS} label={this.props.t('local:view.courses.translateDraft.tabs.sessions.label')} onClick={(e) => this.props.handleClearActiveErrors()}>
                <CoursesTranslateSessionsForm {...this.props} />
              </FormTab>
            </FormTabs>
          </GelContentContainer>
        </Fragment>}
      </Fragment>
    )
  }
}

export default withAssets(withTranslation('local')(CoursesTranslateForm));
